import { AboutContentMode } from '../enum/EnumRepository';

export const DEFAULT_CAREER_CURRENT_LABEL = 'Present';

export const getCareerCurrentLabel = (
  currentLabelOrig: string,
  contentMode: AboutContentMode,
): string =>
  contentMode === AboutContentMode.ENG
    ? DEFAULT_CAREER_CURRENT_LABEL
    : currentLabelOrig;
